

import React from "react";
import "./css/Home.css";
import "./css/Header.css";
import ProjectCard from "./ProjectCard";
import { useProjectsWithLikes } from "../../hooks/useProjectsWithLikes";

const urls = {
  github: "https://github.com/jamescer",
  linkedin: "https://linkedin.com/in/jamescerniglia",
  twitter: "https://twitter.com/jamescerniglia"
};




const Home = () => {
  const projects = useProjectsWithLikes();
  const projectsShown = projects.map((project1) => (
    <ProjectCard key={project1.id} project={project1} />
  ));

  return (
    <main className="os-main">
      <section className="os-home-card">
        <div className="os-home-row">
          <div className="os-home-img-col">
            <img src="./img/me.jpg" className="os-pic-of-me" alt="me" />
          </div>
          <div className="os-home-info-col">
            <h2 className="os-title">James Cerniglia</h2>
            <h4 className="os-desc">Software Engineer III</h4>
            <div className="os-landing-buttons">
              <a className="os-nav-link os-btn" href="#/projects">View Projects</a>
              <a className="os-nav-link os-btn" href="../JamesCernigliaResume.pdf">View Resume</a>
            </div>
            <div className="os-social-icons">
              <a className="os-social-icon" href={urls.github} target="_blank" rel="noopener noreferrer">
                <i className="fab fa-github fa-2x" />
              </a>
              <a className="os-social-icon" href={urls.linkedin} target="_blank" rel="noopener noreferrer">
                <i className="fab fa-linkedin fa-2x" />
              </a>
              <a className="os-social-icon" href={urls.twitter} target="_blank" rel="noopener noreferrer">
                <i className="fab fa-twitter-square fa-2x" />
              </a>
            </div>
          </div>
        </div>
      </section>
      <section className="os-projects-container">
        <h4 className="os-projects-title">Projects</h4>
        <div className="os-projects-row">
          {projectsShown}
        </div>
      </section>
    </main>
  );
};

export default Home;
